export enum PURPOSE_NAMES {
  COMPANY_NAME = 'companyname',
  FULL_NAME = 'fullname',
  FAMILY_NAME = 'familyname',
  MAIN_TEXT = 'headline/maintext',
  ADDITIONAL_TEXT = 'yourtexthere/additionaltext',
}

type TemplateField = {
  purposeName: PURPOSE_NAMES
  placeholder: string
}
export interface UsePersonalizationConfigOutput {
  isEnabled: boolean
  mode: 'modal' | 'sidebar'
  imageCopyKey: string
  templateFields: TemplateField[]
}
